import React, { useState } from "react";
import {
  PartWithInventory,
  useUpdateReelDetails,
} from "../../../utils/hooks/inventory/boardInventory";
import {
  EditableCellContainer,
  ModalContainer,
  Title,
  VerticalList,
} from "./BoardInventoryStyles";
import Button from "../../common/Button";
import FlashPCBSelect from "../../common/FlashPCBSelect";
import { EditButton } from "../../ReviewBoardFlow/BillOfMaterials/ElementsTable/ElementsTableStyles";
import Icon from "../../common/Icon";
import Modal from "../../common/Modal";
import ModalContentWithCloseButton from "../../common/ModalContentWithCloseButton";
import LoadingOverlay from "../../LoadingOverlay";
import { InputLabel } from "../../../constants/Styles";
import { useFlashPCBSettings } from "../../../utils/hooks/commonly-stored/flashPCBSettings";

export default function FeederDetailsCell({
  part,
}: {
  part: PartWithInventory;
}) {
  const [width, setWidth] = useState<number | null>(
    part.part.reel_details?.reel_width_mm,
  );
  const [pitch, setPitch] = useState<number | null>(
    part.part.reel_details?.reel_pitch_mm,
  );
  const [updateFeederDetailsModalOpen, setUpdateFeederDetailsModalOpen] =
    useState(false);
  const { updateReelDetails, loading } = useUpdateReelDetails(part.part.id);
  const flashPCBSettings = useFlashPCBSettings();
  const handleSelectWidthChange = (
    newValue: { label: string; value: number } | null,
  ) => {
    if (newValue?.value) {
      setWidth(newValue.value);
    }
  };

  const handleSelectPitchChange = (
    newValue: { label: string; value: number } | null,
  ) => {
    if (newValue?.value) {
      setPitch(newValue.value);
    }
  };

  const updateReel = () => {
    updateReelDetails(width, pitch);
    setUpdateFeederDetailsModalOpen(false);
  };

  return (
    <EditableCellContainer>
      <LoadingOverlay loading={loading} text={"Updating reel details..."} />
      <VerticalList>
        <InputLabel>Reel width: </InputLabel>{" "}
        <div>{`${part.part.reel_details?.reel_width_mm !== null ? `${part.part.reel_details?.reel_width_mm} mm` : "Unknown"}`}</div>
        <InputLabel>Reel pitch: </InputLabel>
        <div>
          {`${part.part.reel_details?.reel_pitch_mm !== null ? `${part.part.reel_details?.reel_pitch_mm} mm` : "Unknown"}`}
        </div>
        <EditButton
          onClick={() => setUpdateFeederDetailsModalOpen(true)}
          disabled={loading}
        >
          <Icon src="/icons/pencil.svg" alt="edit" />
        </EditButton>
      </VerticalList>
      <Modal
        isOpen={!loading && updateFeederDetailsModalOpen}
        onRequestClose={() => setUpdateFeederDetailsModalOpen(false)}
      >
        <ModalContentWithCloseButton
          closeModal={() => setUpdateFeederDetailsModalOpen(false)}
        >
          <ModalContainer>
            <Title>{`Update reel details for ${part.part.name}`}</Title>
            <FlashPCBSelect
              label={"Reel width"}
              placeholder={"Select reel width"}
              value={width ? { value: width, label: width.toString() } : null}
              onChange={handleSelectWidthChange}
              options={flashPCBSettings?.reel_size_options.reel_width_mm.map(
                (option) => ({
                  label: `${option} mm`,
                  value: option,
                }),
              )}
            />
            <FlashPCBSelect
              label={"Reel pitch"}
              placeholder={"Select reel pitch"}
              value={pitch ? { value: pitch, label: `${pitch} mm` } : null}
              onChange={handleSelectPitchChange}
              options={flashPCBSettings?.reel_size_options.reel_pitch_mm.map(
                (option) => ({
                  label: `${option} mm`,
                  value: option,
                }),
              )}
            />
            <Button label={"Submit"} onClick={updateReel} />
            <Button
              label={"Cancel"}
              onClick={() => setUpdateFeederDetailsModalOpen(false)}
            />
          </ModalContainer>
        </ModalContentWithCloseButton>
      </Modal>
    </EditableCellContainer>
  );
}
